const rows = [
  {
    yours: "Icebreakers · Team lunches · Trust falls",
    ours: "Live behavioural experiments with real pressure",
  },
  {
    yours: "Post-event smiles · No data",
    ours: "CSSDPH debrief · scored, mapped, defensible",
  },
  {
    yours: "'How did we like it?' feedback forms",
    ours: "Decision patterns leadership can act on",
  },
];

export default function Mission() {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-28 lg:py-36 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-5">
            <div className="sticky top-28">
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-6 flex items-center gap-3">
                <span className="w-8 h-px bg-[#dc2626]" /> 01 · The Mission
              </div>
              <h2
                data-testid="mission-title"
                className="font-display uppercase font-black text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
              >
                We don&apos;t change how your people <span className="text-[#dc2626]">work</span>.
                <br />
                We change how your <span className="text-neutral-500">organization</span> sees them.
              </h2>
              <p className="mt-8 text-neutral-400 max-w-md leading-relaxed">
                Lunipin builds the game. The debrief is where the real work happens. Every
                format is powered by one engine: a real storyline, real pressure, a
                behavioural report leadership can actually use.
              </p>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:pl-12">
            <div className="border border-white/10 bg-[#0a0a0a] p-8 md:p-10">
              <div className="grid grid-cols-2 gap-6 pb-6 border-b border-white/10">
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                  What most vendors ship
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#dc2626]">
                  What Lunipin ships
                </div>
              </div>
              <div className="divide-y divide-white/5">
                {rows.map((r, i) => (
                  <div key={i} className="grid grid-cols-2 gap-6 py-6" data-testid={`mission-row-${i}`}>
                    <div className="text-neutral-500 line-through decoration-[#dc2626]/40">
                      {r.yours}
                    </div>
                    <div className="text-white font-medium">{r.ours}</div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.25em]">
                <span className="text-[#f59e0b]">DOSSIER ID</span>
                <span className="redacted">SANJAY.BHANDARKAR.K</span>
                <span className="text-neutral-600">/</span>
                <span className="redacted">FOUNDER · CREATOR</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
